import type { IframeHTMLAttributes } from "react";
import { useRevealOnApproach } from "~/utils/use-reveal-on-approach";

type Props = IframeHTMLAttributes<HTMLIFrameElement> & { src: string; title: string };

/** For animation slots whose existing parent reserves the box. The document
 * pauses its own motion; this gate prevents even creating it before approach. */
export function DeferredAnimationFrame(props: Props) {
  const [ref, revealed] = useRevealOnApproach<HTMLDivElement>();
  return (
    <div ref={ref} className="h-full w-full" data-deferred-animation={props.src}>
      {revealed ? <iframe {...props} /> : null}
    </div>
  );
}
